import React from "react";
const HorizontalLine = () => {
    const hr = {
        width: 'calc(100% + 64px)',
        height:1,
        position: 'relative',
        left: -32,
        bottom: 0,
        background:'#F0F2FF',
    }
    return(
            <div style={hr}/>
    )
}
export default HorizontalLine;